/**
 * Email API
 * Centralized email sending functions
 */

import { apiClient } from './config';

/**
 * Send email using sender email account
 * @param {string} emailContent - Formatted email content with headers
 * @returns {Promise} Response data
 */
export const sendEmailAsSender = async (emailContent) => {
  const response = await apiClient.post('/send-email-as-sender-email', {
    text: emailContent
  });
  return response.data;
};

/**
 * Generate form link with sections
 * @param {string} patientId - Patient ID
 * @param {string} patientName - Patient name
 * @param {object} requiredSections - Sections configuration
 * @returns {Promise} Form link data
 */
export const generateFormLink = async (patientId, patientName, requiredSections) => {
  const response = await apiClient.post('/generate-form-link', {
    patientId,
    patientName,
    requiredSections
  });
  return response.data;
};

/**
 * Generate consultation form link
 * @param {string} patientId - Patient ID
 * @param {string} patientName - Patient name
 * @param {object} requiredSections - Sections configuration
 * @param {object} additionalClauses - Additional clauses
 * @returns {Promise} Consultation link data
 */
export const generateConsultationLink = async (patientId, patientName, requiredSections, additionalClauses) => {
  const response = await apiClient.post('/generate-consultation-link', {
    patientId,
    patientName,
    requiredSections,
    additionalClauses
  });
  return response.data;
};

/**
 * Build email content with headers
 * @param {object} params - Email parameters
 * @param {string} params.to - Recipient email
 * @param {string} params.subject - Email subject
 * @param {string} params.body - HTML body
 * @param {string} params.cc - CC emails (optional)
 * @param {string} params.bcc - BCC emails (optional)
 * @returns {string} Formatted email content
 */
export const buildEmailContent = ({ to, subject, body, cc = '', bcc = '' }) => {
  let content = `To: ${to}\r\n`;
  if (cc) content += `Cc: ${cc}\r\n`;
  if (bcc) content += `Bcc: ${bcc}\r\n`;
  content += `Subject: ${subject}\r\n`;
  content += `Content-Type: text/html; charset="UTF-8"\r\n`;
  content += `Content-Transfer-Encoding: 7bit\r\n\r\n`;
  content += `<p>${body}</p>`;
  return content;
};
